import { ExternalLink, Note } from "@octopusdeploy/design-system-components";
import * as React from "react";
import type { CategoryDefinition } from "./endpointRegistry";
const category: CategoryDefinition = {
    category: "Kubernetes",
    title: (<React.Fragment>
            Let's connect to a <strong>Kubernetes</strong> cluster.
        </React.Fragment>),
    help: (<Note>
            Learn more about connecting to <ExternalLink href="k8sTargetComparison">Kubernetes clusters</ExternalLink>
        </Note>),
    displayOrder: 10,
};
export default category;
